export default {
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "홈",
  metaTitleProducts: "제품",
  metaTitleProductDetail: "제품 상세",
  metaTitleCustomService: "맞춤 서비스",
  metaTitleSolutions: "솔루션",
  metaTitleAbout: "회사 소개",
  metaTitleContact: "문의하기",
  metaTitleBlog: "블로그",
  metaTitleLogin: "로그인",
  metaTitleAdmin: "관리자 대시보드",
  metaTitleSystemSetup: "시스템 설정",

  contactDocsTitle: "제공 문서",
  contactDocsDesc: "상업 송장, 포장 명세서 및 출하 조율 지원.",
  contactSampleTitle: "샘플 서비스",
  contactSampleDesc: "OEM/프라이빗 라벨 프로젝트를 위한 빠른 샘플 진행.",

  searchOverlayPlaceholder: "제품명을 검색하세요...",
  searchOverlaySubmitAria: "검색 제출",
  searchOverlaySubmitTitle: "검색",
  searchOverlayHintPrefix: "누르세요",
  searchOverlayHintSuffix: "모든 일치 제품을 보거나 아래의 빠른 결과를 선택할 수 있습니다.",
  searchOverlayCloseAria: "검색 닫기",
  searchOverlayQuickResults: "빠른 결과",
  searchOverlayQuickResultsAria: "빠른 검색 결과",
  searchOverlayFallbackCategory: "요가 액세서리",
  searchOverlayHistory: "검색 기록",
  searchOverlayClear: "지우기",
  searchOverlayNoHistory: "최근 검색이 없습니다",
  searchOverlayRecommended: "추천 키워드",
  searchOverlayFallbackKeyword: "요가 매트",

  blogHeroKicker: "콘텐츠 센터",
  blogHeroTitle: "인사이트 및 구매 가이드",
  blogSearchAria: "기사 검색",
  blogReadingTimeMin: "분 읽기",
  blogShowLess: "접기",
  blogCategoryAria: "기사 카테고리",
  blogFeaturedPlaceholder: "추천 인사이트",
  blogPaginationAria: "블로그 페이지네이션",
  blogCtaAria: "블로그 CTA",
  blogCtaDescription: "샘플 단계부터 대량 납품까지, 상황에 맞는 제안과 실행 지원을 제공합니다.",
  blogCtaPrimary: "지금 문의",
  blogCtaSecondary: "솔루션 보기",

  requestFreeSample: "무료 샘플 요청",

  factoryStatsSince: "2008년부터 수출",
  factoryStatsCapacity: "월 10,000+ 생산",
  factoryStatsExport: "50개국 이상 공급",
  factoryStatsCert: "ISO 9001 및 BSCI 인증",

  aboutHeroTitle: "젊고, 전문적이며, 집중된 — 요가 공급망 통합의 전문가",
  aboutHeroBody: "중국 후난성 창사에 위치한 LOYA SPORT는 역동적이고 전문적인 팀을 갖추고 있습니다. 우리는 해외 바이어에게 소스 공장 선별부터 심층 맞춤 개발까지 전 과정을 아우르는 요가 공급망 통합 서비스를 제공합니다.",
  aboutAddress: "주소: 중국 후난성 창사시 위에루구 왕룽로 루이허 커촹 빌딩",
  aboutTeamTitle: "젊고 전문적인 팀",
  aboutTeamBody: "우리는 젊지만 경험이 풍부하며, 요가 산업의 시장 수요와 기술적 세부 사항을 깊이 이해하고 있습니다. 엄격한 선별 기준과 빠른 대응 속도를 통해 제공되는 모든 제품이 높은 상업적 기대를 충족하도록 보장합니다.",
  aboutCustomizationTitle: "종합 맞춤 서비스",
  aboutCustomizationBody: "로고 인쇄와 패키지 디자인부터 제품 기능 금형 개발까지, 우리는 브랜드가 시장에서 돋보일 수 있도록 유연하고 심층적인 맞춤 솔루션을 제공합니다.",
  aboutFactoryPartnerTitle: "프리미엄 공장 파트너",
  aboutFactoryPartnerBody: "우리는 ISO/BSCI 인증 제조 거점과 긴밀히 협력하며, 원천부터 품질을 관리하여 안정적인 생산과 정시 납품을 보장합니다.",
  aboutHeroKicker: "공급망 통합 파트너",
  aboutMetric1: "제품, 포장, 납품 소통을 위한 단일 프로젝트 창구",
  aboutMetric2: "하나의 소싱 및 후속 관리 구조 아래 공장 자원 통합",
  aboutMetric3: "수입업체, 소매업체, 유통업체, 프라이빗 라벨 바이어를 위한 워크플로",
  aboutPlaceholderNote: "우리의 역할은 바이어, 공급업체, 공장 실행팀 간에 분산된 소통을 줄여 프로젝트가 더 명확하고 더 적은 리스크로 진행되도록 하는 것입니다.",
  aboutHeroImageAlt: "수출 바이어를 위한 공급망 조율 회의",
  aboutHeroCaption: "문의부터 선적까지, 우리는 보통 소싱 에이전트, 공장, 물류 담당자에게 나뉘는 세부 사항을 통합 조율합니다.",
  aboutOfficeImageAlt: "창사 로야 테크놀로지 사무실 건물",
  aboutOfficeCaption: "창사 로야 테크놀로지 사무실",
  aboutTeamImageAlt: "창사 사무실의 전문 팀",
  aboutFactoryImageAlt: "요가 매트 생산 라인 및 품질 워크플로",
  aboutFactoryCollageAlt: "공장 창고 및 생산 세부 사항",
  aboutWhatWeDoTitle: "우리가 실제로 하는 일",
  aboutWhatWeDoBody1: "많은 바이어는 단순한 카탈로그만 필요한 것이 아닙니다. 그들은 상업적 요구사항을 실제 공장 실행과 연결할 수 있는 파트너를 필요로 합니다. 바로 그 지점에서 우리가 역할을 합니다. 우리는 공급업체 선정, 가격 협의, 샘플 진행, 포장 실행, 생산 추적, 검사 정렬, 수출 준비를 조율합니다.",
  aboutWhatWeDoBody2: "제품 세부사항, 포장 파일, 납기 일정, 주문 변경 사항을 여러 담당자에게 흩어 놓는 대신, 우리는 이를 하나의 책임 있는 커뮤니케이션 경로로 통합해 프로젝트가 지속적으로 전진하도록 합니다.",
  aboutBadge1: "공급업체 매칭",
  aboutBadge2: "샘플 후속 관리",
  aboutBadge3: "포장 실행",
  aboutBadge4: "선적 준비",
  aboutSideImageAlt: "바이어 커뮤니케이션 및 프로젝트 검토",
  aboutIntegratedCapabilitiesTitle: "통합 공급 역량",
  aboutSideCaption: "우리는 단순 거래보다 신뢰할 수 있는 조율이 더 중요한 해외 바이어를 위해 공급망을 더 쉽게 관리할 수 있도록 만드는 데 집중합니다.",
  aboutCapabilityCard1Title: "공급업체 네트워크 통합",
  aboutCapabilityCard1Body: "우리는 공장 자원, 카테고리 지식, 소싱 통제를 하나의 바이어 중심 워크플로로 통합하여 여러 당사자를 직접 조율할 필요를 줄여 줍니다.",
  aboutCapabilityCard2Title: "상업 및 기술 조율",
  aboutCapabilityCard2Body: "견적, 샘플, 포장 세부 사항부터 사양 확인과 생산 체크포인트까지, 우리는 영업 측면과 공장 측면이 일치하도록 유지합니다.",
  aboutCapabilityCard3Title: "수출 주문 실행",
  aboutCapabilityCard3Body: "검사, 문서, 선적 예약, 출하 준비까지 주문을 추적하여 커뮤니케이션 공백과 납품 리스크를 줄입니다.",
  aboutOperatingModel1: "목표 시장과 가격 포지셔닝에 기반한 카테고리 소싱 및 공장 매칭.",
  aboutOperatingModel2: "생산 확정 전 샘플, 사양 검토 및 포장 조율.",
  aboutOperatingModel3: "하나의 프로젝트 흐름 아래 생산 추적, 품질 체크포인트, 선적 준비.",
  aboutOperatingModel4: "제품, 포장, 문서, 납품 진행 상황을 위한 단일 커뮤니케이션 창구.",
  aboutWhoWeServeTitle: "우리가 지원하는 고객",
  aboutBuyerScenario1Title: "수입업체 및 유통업체용",
  aboutBuyerScenario1Body: "우리는 제품 라인을 통합하고, 공급업체 옵션을 비교하며, 카테고리 전반에 걸쳐 보다 안정적인 재보충 계획을 구축하도록 지원합니다.",
  aboutBuyerScenario2Title: "리테일 체인 및 이커머스 판매자용",
  aboutBuyerScenario2Body: "출시 가능한 상품 구성, 프라이빗 라벨 포장, 반복 주문에 적합한 실용적인 커뮤니케이션을 지원합니다.",
  aboutBuyerScenario3Title: "제품 라인을 확장하는 브랜드용",
  aboutBuyerScenario3Body: "우리는 고객의 콘셉트, 생산 측면, 수출 실행 사이의 조율 레이어로 작동하여 내부 팀이 더 빠르게 움직일 수 있도록 합니다.",
  aboutWorkflowTitle: "우리의 워크플로 구조",
  aboutWorkflowStep1: "요구사항 접수 및 목표 제품 명확화",
  aboutWorkflowStep2: "공급업체 매칭, 견적 및 샘플 계획",
  aboutWorkflowStep3: "사양, 포장 및 컴플라이언스 검토",
  aboutWorkflowStep4: "생산 추적, 검사 및 출하 준비",
  aboutWhyIntegratorTitle: "왜 바이어는 공급망 통합 파트너를 선택하는가",
  aboutWhyIntegratorBody1: "소싱이 여러 공급업체, 포장 벤더, 선적 일정에 걸쳐 있을 때 가장 큰 리스크는 최초 견적 자체가 아닙니다. 주문이 진행되기 시작한 후 정렬이 무너지는 것이 더 큰 문제입니다.",
  aboutWhyIntegratorList1: "사양이 견적 단계와 생산 단계 사이에서 달라질 수 있습니다.",
  aboutWhyIntegratorList2: "포장 및 브랜딩 세부 사항이 분산된 커뮤니케이션으로 인해 지연될 수 있습니다.",
  aboutWhyIntegratorList3: "검사, 서류, 선적 준비가 원래의 상업적 약속과 분리될 수 있습니다.",
  aboutWhyIntegratorBody2: "우리의 가치는 이 요소들을 계속 연결 상태로 유지하는 데 있습니다. 우리는 바이어 기대치와 공급업체 실행 사이의 조율 레이어로서, 의사결정을 문서화하고 일정을 추적하며 인수인계 리스크를 줄입니다.",
  aboutTalkToTeam: "팀과 상담하기",
  aboutPositioningTitle: "우리의 포지셔닝",
  aboutPositioningBody: "LOYA SPORT는 수출 지향 피트니스 제품을 위한 공급망 통합 파트너로 자리매김하고 있습니다. 우리는 고객이 더 명확한 조율, 더 강한 공급업체 조직력, 더 관리하기 쉬운 소싱-출하 경로를 통해 구매할 수 있도록 돕습니다.",

  solutionsHeroKicker: "솔루션",
  solutionsHeroTitle: "바이어 유형에 맞는 소싱 경로를 선택하세요",
  solutionsHeroBody: "채널 적합성, 시나리오 적합성, 제품 프로그램 계획을 위한 시각 가이드로 설계되었습니다.",
  solutionsTalkToSales: "영업팀 상담",
  solutionsBrowseProducts: "제품 둘러보기",
  solutionsHeroImageAlt: "요가 및 라이트 피트니스 바이어를 위한 B2B 소싱 솔루션",
  solutionsHeroBadgeTitle: "솔루션 적합도",
  solutionsHeroBadgeBody: "바이어 유형 + 사용 시나리오 + 제품 구성",
  solutionsBuyerTypeTitle: "바이어 유형별 솔루션",
  solutionsViewMatchingProducts: "적합한 제품 보기",
  solutionsScenarioPlansTitle: "시나리오 플랜",
  solutionsProgramMixesTitle: "추천 프로그램 구성",
  solutionsNextStepKicker: "다음 단계",
  solutionsNextStepTitle: "시장에 맞는 맞춤 구성이 필요하신가요?",
  solutionsNextStepBody: "바이어 유형, 목표 제품, 대상 시장을 알려주시면 실용적인 구성 경로를 제안해 드립니다.",
  solutionsRequestPlan: "솔루션 플랜 요청",
  solutionsExploreOem: "OEM 지원 살펴보기",
  solutionsBuyerCard1Title: "도매업체",
  solutionsBuyerCard1Subtitle: "대량 프로그램을 위한 빠른 상품 구성.",
  solutionsBuyerCard1Need1: "품절 리스크를 줄이면서 안정적인 대량 공급이 필요",
  solutionsBuyerCard1Need2: "재판매 속도를 높이기 위한 카톤 단위 SKU 구성이 필요",
  solutionsBuyerCard1Need3: "예측 가능한 리드타임의 반복 재주문 주기가 필요",
  solutionsBuyerCard1Tag1: "대량 구성",
  solutionsBuyerCard1Tag2: "카톤 준비 패키지",
  solutionsBuyerCard1Tag3: "반복 재보충",
  solutionsBuyerCard2Title: "소매업체",
  solutionsBuyerCard2Subtitle: "진열 준비 패키지와 안정적인 재보충.",
  solutionsBuyerCard2Need1: "보급형부터 프리미엄까지 명확한 가격 단계가 필요",
  solutionsBuyerCard2Need2: "빠른 진열 등록을 위한 바코드 준비 포장이 필요",
  solutionsBuyerCard2Need3: "회전율 높은 상품에 대한 신뢰성 있는 재보충이 필요",
  solutionsBuyerCard2Tag1: "리테일 패키지",
  solutionsBuyerCard2Tag2: "바코드 지원",
  solutionsBuyerCard2Tag3: "진열 친화적 구성",
  solutionsBuyerCard3Title: "피트니스 브랜드",
  solutionsBuyerCard3Subtitle: "브랜드 확장을 위한 프라이빗 라벨 프로그램.",
  solutionsBuyerCard3Need1: "전체 공급망을 다시 구축하지 않고도 맞춤 브랜딩이 필요",
  solutionsBuyerCard3Need2: "브랜드 포지셔닝에 맞는 포장 스타일이 필요",
  solutionsBuyerCard3Need3: "샘플부터 출시까지의 기간 단축이 필요",
  solutionsBuyerCard3Tag1: "로고 적용",
  solutionsBuyerCard3Tag2: "맞춤 포장",
  solutionsBuyerCard3Tag3: "브랜드 라인 확장",
  solutionsBuyerCard4Title: "요가 스튜디오",
  solutionsBuyerCard4Subtitle: "스튜디오 키트, 소도구, 클래스 번들.",
  solutionsBuyerCard4Need1: "신규 회원 및 체험 수업용 스타터 키트가 필요",
  solutionsBuyerCard4Need2: "고빈도 수업에 적합한 내구성 있는 소도구가 필요",
  solutionsBuyerCard4Need3: "업셀 프로그램을 위한 실용적인 번들 가격이 필요",
  solutionsBuyerCard4Tag1: "스타터 세트",
  solutionsBuyerCard4Tag2: "클래스 소도구",
  solutionsBuyerCard4Tag3: "회원 업그레이드 키트",
  solutionsBuyerCard5Title: "Amazon 판매자",
  solutionsBuyerCard5Subtitle: "마켓플레이스 준비형 번들과 포장.",
  solutionsBuyerCard5Need1: "배송비를 통제하기 위한 컴팩트한 번들 구조가 필요",
  solutionsBuyerCard5Need2: "전환율을 높이는 리스팅 친화적 제품 조합이 필요",
  solutionsBuyerCard5Need3: "반품률을 낮추는 포장 품질이 필요",
  solutionsBuyerCard5Tag1: "컴팩트 번들",
  solutionsBuyerCard5Tag2: "이미지 준비 포장",
  solutionsBuyerCard5Tag3: "저마찰 출시",
  solutionsBuyerCard6Title: "이커머스 기업",
  solutionsBuyerCard6Subtitle: "반복 온라인 판매를 위한 비주얼 중심 제품.",
  solutionsBuyerCard6Need1: "광고 및 소셜 트래픽에서 성과가 좋은 핵심 SKU가 필요",
  solutionsBuyerCard6Need2: "AOV를 높일 수 있는 유연한 번들이 필요",
  solutionsBuyerCard6Need3: "시즌성 캠페인을 위한 빠른 카탈로그 업데이트가 필요",
  solutionsBuyerCard6Tag1: "핵심 상품",
  solutionsBuyerCard6Tag2: "번들 로직",
  solutionsBuyerCard6Tag3: "빠른 카탈로그 갱신",
  solutionsScenario1Title: "스튜디오 스타터 세트",
  solutionsScenario1Body: "수업, 체험, 멤버십 패키지를 위한 출시 준비형 요가 번들.",
  solutionsScenario2Title: "회복 및 마사지 존",
  solutionsScenario2Body: "헬스장 코너용 마사지 도구, 롤러 및 회복 액세서리.",
  solutionsScenario3Title: "리테일 디스플레이 프로그램",
  solutionsScenario3Body: "매장 진열에 적합한 포장을 갖춘 균형 잡힌 상품 구성.",
  solutionsScenario4Title: "온라인 번들 오퍼",
  solutionsScenario4Body: "전환 중심 상품 페이지를 위해 설계된 컴팩트한 키트.",
  solutionsProgram1Title: "스튜디오 런칭 믹스",
  solutionsProgram1Body: "클래스 기반 요가 비즈니스를 위한 깔끔한 스타터 상품 구성.",
  solutionsProgram1Item1: "요가 매트",
  solutionsProgram1Item2: "블록 및 스트랩",
  solutionsProgram1Item3: "마사지 액세서리",
  solutionsProgram1SuitedFor: "스튜디오 / 트레이너",
  solutionsProgram2Title: "리테일 선반 프로그램",
  solutionsProgram2Body: "명확한 가격 단계와 반복 주문이 필요한 매장을 위한 균형 잡힌 제품군.",
  solutionsProgram2Item1: "핵심 매트",
  solutionsProgram2Item2: "필라테스 소도구",
  solutionsProgram2Item3: "즉시 구매형 회복 도구",
  solutionsProgram2SuitedFor: "소매업체 / 유통업체",
  solutionsProgram3Title: "온라인 번들 패키지",
  solutionsProgram3Body: "PDP 비주얼과 더 쉬운 온라인 전환을 위해 설계된 컴팩트한 제품 세트.",
  solutionsProgram3Item1: "미니 키트",
  solutionsProgram3Item2: "선물용 패키지",
  solutionsProgram3Item3: "프라이빗 라벨 인서트",
  solutionsProgram3SuitedFor: "Amazon / 이커머스",

  contactResponseTitle: "평균 응답 시간",
  contactResponseDesc: "표준 RFQ 요청 기준 8영업시간 이내.",

  carouselLoadingTitle: "배너 이미지를 불러오는 중",
  carouselLoadingBody: "홈페이지 비주얼을 준비하고 있습니다. 배너 이미지가 로드될 때까지 잠시만 기다려 주세요.",
  carouselPlaceholderTitle: "배너 이미지를 준비 중입니다",
  carouselPlaceholderBody: "이미지 리소스가 준비되면 홈페이지 캐러셀이 여기에 표시됩니다.",

  aboutProductDev: "제품 개발",
  aboutProductDevDesc: "빠른 샘플 사이클과 실용적인 디자인 협업으로 더 빠른 시장 출시를 지원합니다.",
  aboutSupplyReliability: "공급 안정성",
  aboutSupplyReliabilityDesc: "성수기에도 납기가 흔들리지 않도록 안정적인 원자재 조달과 생산 능력 계획을 제공합니다.",
  aboutTradeSupport: "납품 및 애프터서비스 지원",
  aboutTradeSupportDesc: "문서, 선적 조율, 사후 지원을 통해 국제 거래 운영을 더 원활하게 만듭니다.",
  aboutSupplyList1: "요가 및 라이트 피트니스 라인을 위한 검증된 공급업체 조율",
  aboutSupplyList2: "협력 공장과의 다단계 품질 검토",
  aboutSupplyList3: "프라이빗 라벨 및 포장 지원",
  aboutSupplyList4: "주요 지역 및 채널 전반의 글로벌 공급 지원",

  oemCapability1: "핵심 요가 액세서리를 위한 맞춤 로고 인쇄, 엠보싱 및 레이저 마킹.",
  oemCapability2: "목표 시장에 맞춘 색상, 재질, 질감 및 크기 조정.",
  oemCapability3: "리테일 준비형 포장, 인서트 카드, 바코드 라벨 및 카톤 마크.",
  oemCapability4: "스튜디오 세트, Amazon 준비 패키지 및 시즌 프로모션용 번들 개발.",
  oemProcess1Title: "아이디어 공유",
  oemProcess1Body: "목표 제품, 로고 파일, 참고 이미지, 포장 기대사항 및 예상 수량을 보내주세요.",
  oemProcess2Title: "사양 및 MOQ 확인",
  oemProcess2Body: "재질 옵션, 브랜딩 방식, 컴플라이언스 포인트, 리드타임 및 실행 가능한 시작 수량을 검토합니다.",
  oemProcess3Title: "샘플 및 수정",
  oemProcess3Body: "샘플 또는 목업을 준비하고, 고객 피드백을 반영한 후 계약금 전 생산 기준을 확정합니다.",
  oemProcess4Title: "대량 생산 및 검사",
  oemProcess4Body: "승인된 샘플을 기준으로 생산을 진행하며, 포장 점검과 선적 전 품질 검토를 수행합니다.",

  news1Title: "봄 시즌 소싱 가이드 공개",
  news1Body: "다가오는 리테일 시즌을 위한 최신 요가, 필라테스, 회복 제품 트렌드를 확인하세요.",
  news2Title: "OEM 포장 업데이트",
  news2Body: "이제 프라이빗 라벨 프로그램을 위해 더 친환경적인 카톤, 인서트 카드, 바코드 포장 옵션을 지원합니다.",
  news3Title: "수출 일정 안내",
  news3Body: "바이어가 출시 일정을 더 정확하게 관리할 수 있도록 리드타임 계획과 선적 윈도우를 매주 업데이트합니다.",

  navYogaMats: "요가 매트",
  navYogaBlocks: "요가 블록",
  navYogaStraps: "요가 스트랩",
  navResistanceBands: "저항 밴드",
  navPilatesRings: "필라테스 링",
  navFoamRollers: "폼 롤러",
  navOemPrivateLabel: "맞춤 서비스",
  navSolutionsControl: "솔루션",
  navBlog: "블로그",
  navCompanyProfile: "회사 소개",
  navContactUs: "문의하기",
  seeAllCategories: "모든 카테고리 보기",

  productDetailReady: "프라이빗 라벨 가능",
  productDetailQuote: "견적 문의",
  productDetailViewSpecs: "사양 보기",
  productDetailRequestQuote: "견적 요청",

  pdLoadErrorProductDetail: "제품 상세 정보를 불러오지 못했습니다",
  pdLoadErrorRelatedProducts: "관련 제품을 불러오지 못했습니다",
  pdLoadErrorStorefrontConfig: "스토어프론트 설정을 불러오지 못했습니다",
  pdLoading: "제품 상세 정보를 불러오는 중...",
  pdSampleDefaultMessage: "샘플 정책, 리드타임 및 견적 세부 정보를 알려주세요.",
  pdAttrProductName: "제품명",
  pdAttrModelNo: "모델 번호",
  pdAttrCategory: "카테고리",
  pdAttrManufacturer: "제조사",
  pdLeadTimeOnRequest: "리드타임 문의",
  pdLeadTimeUpTo: "{qty}개 이하: {days}일",
  pdLeadTimeFrom: "{qty}개 이상: {days}일",
  pdLeadTimeDaysOnly: "{days}일",
  pdContactForQuote: "견적 문의",
  pdPerPiece: "{price} / 개",
  pdAnonymousBuyer: "익명 바이어",
  pdReviewTipSignIn: "도움됨 투표를 하려면 고객 계정으로 로그인해 주세요.",
  pdReviewTipSessionExpired: "세션이 만료되었습니다. 다시 로그인해 주세요.",
  pdReviewTipNoPermission: "현재 계정은 도움됨 투표 권한이 없습니다.",
  pdReviewTipUpdateFailed: "도움됨 상태를 업데이트하지 못했습니다",
  pdSpecValues: "값",
  pdSpecRequired: "필수",
  pdSpecOptional: "선택",
  pdCapabilityCustomLogo: "맞춤 로고 적용",
  pdCapabilitySampleDev: "샘플 기반 개발",
  pdCapabilityPackagingCoordination: "포장 조율",
  pdCapabilityExportFollowUp: "수출 출하 후속 지원",
  pdPackagingSellingUnit: "판매 단위",
  pdPackagingSingleItem: "단품",
  pdPackagingType: "포장",
  pdPackagingTypeFallback: "OPP 백 / 수출 카톤",
  pdPackagingLoadingAdvice: "적재 안내",
  pdPackagingLoadingAdviceFallback: "주문 구조에 따라",
  pdPackagingLeadTime: "리드타임",
  pdMediaPhotoLabel: "사진 {index}",
  pdMediaVideoLabel: "동영상",
  pdMediaAttributesLabel: "속성",
  pdPackagingPointPackaging: "포장: {value}",
  pdPackagingPointLoadingAdvice: "적재 안내: {value}",
  pdPackagingPointShippingPort: "선적 항구: {value} (협의 가능)",
  pdPackagingPointShippingPortNegotiable: "선적 항구: 협의 가능",
  pdPackagingPointLeadTime: "리드타임: {value}",
  pdInquiryHello: "안녕하세요, 다음 제품에 대해 문의하고 싶습니다:",
  pdInquiryProduct: "제품: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "SKU 이름: {value}",
  pdInquiryModel: "모델: {value}",
  pdInquiryQuantity: "수량: {value}",
  pdEmailSubject: "문의: {sku} - {name}",
  pdInquirySubmitFailed: "지금은 문의를 제출할 수 없습니다.",
  pdSampleContactPerson: "담당자: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "회사: {value}",
  pdSampleRequestedQuantity: "요청 수량: {value}",
  pdSampleSelectorQuantity: "페이지 수량 선택값: {value}",
  pdVariationLabel: "옵션",
  pdVariationInquiryIntro: "안녕하세요, 다음 제품에 대해 문의를 보내고 싶습니다:",
  pdVariationInquiryQuoteLeadTime: "최신 견적과 리드타임을 알려주세요.",
  pdVideoFallback: "동영상을 불러오지 못했습니다. 다시 시도하거나 원본 링크를 직접 열어 주세요.",
  pdRetry: "다시 시도",
  pdOpenVideoUrl: "동영상 URL 열기",
  pdProductAttributes: "제품 속성",
  pdMediaTabsAria: "제품 미디어 유형",
  pdMediaTabPhotos: "사진",
  pdMediaTabVideo: "동영상",
  pdMediaTabAttributes: "속성",
  pdInfoTabsAria: "상세 정보 탭",
  pdInfoTabAttributes: "속성",
  pdInfoTabDescription: "설명",
  pdInfoTabSupplier: "공급업체",
  pdInfoTabReviews: "리뷰",
  pdKeyAttributes: "핵심 속성",
  pdPackagingShippingInfo: "포장 및 배송 정보",
  pdProductDescription: "제품 설명",
  pdSupplierOverview: "공급업체 개요",
  pdSupplierOverviewHint: "회사 소개와 FAQ는 상세 이미지 아래에 표시됩니다.",
  pdBuyerFeedback: "구매자 피드백",
  pdRepeatBuyer: "재구매 바이어",
  pdReviewRatingAria: "평점 {rating} / 5",
  pdReviewMetaColor: "색상: {value}",
  pdReviewMetaColorFallback: "두 번째",
  pdReviewUnavailable: "이 제품은 더 이상 제공되지 않습니다",
  pdReviewHelpful: "도움됨 ({count})",
  pdNoReviews: "이 제품에는 아직 리뷰가 없습니다.",
  pdNoReviewsHint: "주문 참고 사례나 샘플 피드백이 필요하시면 저희 팀에 문의해 주세요.",
  pdTitleFallback: "제품 상세",
  pdCustomizable: "맞춤 가능",
  pdVariationCardAria: "제품 옵션",
  pdVariations: "옵션",
  pdSelectNow: "지금 선택",
  pdSelectOption: "옵션 선택",
  pdLadderPricingAria: "구간별 가격",
  pdProductSpecifications: "제품 사양",
  pdSpecPrevAria: "이전 사양 값 보기",
  pdSpecNextAria: "다음 사양 값 보기",
  pdSupplierCapability: "공급업체 커스터마이징 역량",
  pdGetFreeSample: "무료 샘플 받기",
  pdWhatsAppInquiry: "WhatsApp 문의",
  pdEmailInquiry: "이메일 문의",
  pdPackagingDelivery: "포장 및 배송",
  pdProductVideo: "제품 동영상",
  pdVideoOpenLink: "현재 환경에서는 동영상을 재생할 수 없습니다.",
  pdSupplierDescriptions: "공급업체 제공 제품 설명",
  pdCompanyIntroduction: "회사 소개",
  pdNoCompanyIntroduction: "구성된 회사 소개가 없습니다.",
  pdFaq: "FAQ",
  pdNoFaq: "구성된 FAQ가 없습니다.",
  pdCloseVariationSelector: "옵션 선택기 닫기",
  pdVariationSelectAndQty: "옵션 및 수량 선택",
  pdVariationStock: " / 재고 {count}",
  pdSelectedQuantity: "선택된 수량",
  pdSendInquiry: "문의 보내기",
  pdChatNow: "지금 채팅",
  pdOptionLabel: "옵션 {index}",
  pdRelatedAria: "관련 제품",
  pdRelatedTitle: "관련 제품",
  pdRelatedSubtitle: "이 카테고리에서 함께 소싱하는 제품을 더 확인하세요.",
  pdRelatedPrevAria: "이전 관련 제품",
  pdRelatedNextAria: "다음 관련 제품",
  pdSampleContactTitle: "문의해 주세요",
  pdSampleContactDesc: "궁금한 점이 있으신가요? WhatsApp 또는 이메일로 문의 주시면 샘플 지원을 도와드립니다.",
  pdSampleCloseAria: "샘플 문의 닫기",
  pdSampleSummaryProduct: "제품",
  pdSampleSummaryQuantity: "수량",
  pdFormFullName: "성명",
  pdFormFullNamePlaceholder: "이름",
  pdFormEmail: "이메일*",
  pdFormEmailPlaceholder: "이메일로 연락드립니다",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "WhatsApp으로 연락드립니다",
  pdFormCompany: "회사명",
  pdFormCompanyPlaceholder: "회사명",
  pdFormRequiredQuantity: "필요 수량",
  pdFormRequiredQuantityPlaceholder: "샘플 또는 테스트 필요 수량",
  pdFormMessage: "메시지",
  pdFormMessagePlaceholder: "제품 요구사항을 간단히 설명해 주세요",
  pdFormSending: "전송 중...",
  pdFormSendMessage: "메시지 보내기",
  pdFormInquirySuccess: "문의가 성공적으로 접수되었습니다.",

  oemHeroKicker: "맞춤 서비스",
  oemTitle: "명확한 생산 워크플로로 맞춤형 요가 라인을 구축하세요",
  oemIntro: "우리는 해외 바이어를 위해 요가 및 라이트 피트니스 카테고리의 제품 맞춤화, 포장 개발, 샘플 후속 관리 및 주문 실행을 지원합니다.",
  oemStartProject: "맞춤 프로젝트 시작",
  oemBrowseProducts: "기본 제품 보기",
  oemVisualGuide: "맞춤화 시각 가이드",
  oemVisualAlt: "OEM 맞춤 옵션 및 프로세스 가이드",
  oemVisualPlaceholder: "맞춤화 이미지를 찾을 수 없습니다. frontend/public/assets/about/oem-customization-guide.jpg에 이미지를 추가해 주세요.",
  oemCapabilityKicker: "맞춤 가능한 범위",
  oemCapabilityTitle: "로고 적용부터 전체 포장 실행까지",
  oemProjectBrief: "프로젝트 브리프",
  oemServiceShowcaseAria: "OEM 및 ODM 맞춤 서비스",
  oemServiceShowcaseTitle: "OEM & ODM 맞춤 서비스",
  oemServiceShowcaseBody: "콘셉트 검토부터 생산 및 출하 인계까지 유연한 원스톱 지원.",
  oemCompareHeadBody: "기본 제품과 맞춤 결과를 비교하는 네 가지 일반 경로.",
  oemCompareBaseSuffix: "기본 버전",
  oemCompareOptionsSuffix: "맞춤 옵션",
  oemCompareCustomizedSuffix: "맞춤 버전",
  oemCompare1Title: "로고 적용",
  oemCompare1Body: "기본 제품에서 브랜드 표현으로.",
  oemCompare1BeforeLabel: "기본",
  oemCompare1AfterLabel: "로고 포함",
  oemCompare1CustomizationLabel: "로고 추가",
  oemCompare1Item1: "인쇄",
  oemCompare1Item2: "엠보싱",
  oemCompare1Item3: "레이저 마킹",
  oemCompare2Title: "색상 및 마감",
  oemCompare2Body: "중립 사양에서 시장 적합 컬러웨이로.",
  oemCompare2BeforeLabel: "표준",
  oemCompare2AfterLabel: "맞춤 색상",
  oemCompare2CustomizationLabel: "색상 변경",
  oemCompare2Item1: "색상",
  oemCompare2Item2: "질감",
  oemCompare2Item3: "크기",
  oemCompare3Title: "포장 구성",
  oemCompare3Body: "기본 포장에서 리테일 준비 포장으로.",
  oemCompare3BeforeLabel: "기본 포장",
  oemCompare3AfterLabel: "리테일 준비",
  oemCompare3CustomizationLabel: "포장 세부 사항",
  oemCompare3Item1: "인서트 카드",
  oemCompare3Item2: "바코드",
  oemCompare3Item3: "카톤 마크",
  oemCompare4Title: "번들 개발",
  oemCompare4Body: "단품에서 채널 준비형 세트로.",
  oemCompare4BeforeLabel: "단품",
  oemCompare4AfterLabel: "번들 세트",
  oemCompare4CustomizationLabel: "번들 로직",
  oemCompare4Item1: "스튜디오 세트",
  oemCompare4Item2: "Amazon 패키지",
  oemCompare4Item3: "프로모션 믹스",
  oemCasesTitle: "맞춤 사례",
  oemCase1Title: "부티크 스튜디오 스타터 라인",
  oemCase1Summary: "부티크 스튜디오 런칭을 위한 스타터 키트 구성.",
  oemCase1Details: "로고 적용 번들을 12일 내 승인 완료.",
  oemCase2Title: "리테일 프라이빗 라벨 리프레시",
  oemCase2Summary: "더 깔끔한 진열을 위한 포장 외관 업데이트.",
  oemCase2Details: "바이어 승인 속도 향상 및 리테일 일관성 강화.",
  oemCase3Title: "마켓플레이스 준비형 피트니스 번들",
  oemCase3Summary: "이커머스 및 리스팅용 번들 구성 준비 완료.",
  oemCase3Details: "인서트, 바코드 및 대량 생산 검토 준비 완료.",
  oemOrderingFlowKicker: "주문 흐름",
  oemOrderingFlowTitle: "5단계 연락 및 주문 프로세스",
  oemContactFlow1: "제품 목록, 대상 시장, 브랜딩 요청과 함께 초기 문의.",
  oemContactFlow2: "샘플 계획, 리드타임 및 포장 옵션이 포함된 견적.",
  oemContactFlow3: "샘플 확인 및 주문 세부 사항 승인.",
  oemContactFlow4: "계약금, 생산, 검사 및 선적 예약.",
  oemContactFlow5: "잔금 지급, 수출 문서 및 애프터서비스 후속 관리.",
  oemContactSideTitle: "OEM 요청을 논의할 준비가 되셨나요?",
  oemContactSideBody: "로고, 목표 수량, 포장 아이디어를 보내 주세요. 실용적인 견적 경로와 샘플 제안을 드리겠습니다.",
  oemContactSideNote: "선호하는 최초 연락 방식: 아트워크와 목표 선적 시점을 포함한 이메일 또는 문의 양식.",
  oemContactSideCta: "영업팀 문의",

  newsHeroKicker: "업계 업데이트",
  newsTitle: "뉴스 및 업데이트",
  newsIntro: "피트니스 액세서리 바이어를 위한 최신 소싱 인사이트, 제품 출시 소식, 수출 업데이트를 확인하세요.",
  newsSectionTitle: "맞춤 프로젝트 공지나 신규 컬렉션 프리뷰가 필요하시면 최신 카탈로그를 위해 영업팀에 문의해 주세요.",

  contactTitle: "공급업체 문의",
  contactHeroKicker: "비즈니스 문의",
  contactIntro: "제품 요구사항과 목표 시장을 알려 주세요. 저희 팀이 견적 세부 정보와 리드타임 예상으로 답변해 드립니다.",
  contactFormTitle: "문의 보내기",
  contactName: "이름",
  contactEmail: "업무용 이메일",
  contactCompany: "회사명",
  contactMessage: "제품 사양, 수량, 배송 목적지",
  contactSubmit: "문의 보내기",
  contactSent: "메시지가 성공적으로 전송되었습니다.",
  contactInfoTitle: "영업 사무소",
  contactInfoEmail: "이메일",
  contactInfoPhone: "전화",
  contactInfoHours: "업무 시간: 월-토, 09:00-18:00 (GMT+8)",
  contactInfoNote: "선호 채널: 공식 견적은 이메일, 긴급 주문 일정 확인은 전화.",
  contactInquiryGreeting: "안녕하세요, 이 제품에 대해 문의하고 싶습니다:",
  contactInquiryProductPrefix: "제품:",
  contactInquiryQuantity: "수량:",
  contactInquiryDestinationPort: "도착 항구:",

  aboutTitle: "LOYA SPORT 소개",
  aboutIntro: "LOYA SPORT는 글로벌 B2B 바이어를 위한 요가 제품 공급망 통합 파트너입니다.",
  aboutWhoWeAre: "우리는 누구인가",
  aboutWhoWeAreDesc1: "우리는 검증된 공급 파트너와 함께 소싱, 샘플, 브랜딩, 출하 후속 관리를 조율하여 수입업체, 유통업체, 소매업체, 프라이빗 라벨 브랜드를 지원합니다.",
  aboutWhoWeAreDesc2: "우리의 강점은 실용적인 커뮤니케이션, 카테고리 집중력, 그리고 해외 고객이 더 빠르게 움직일 수 있도록 돕는 명확한 구매 워크플로에 있습니다.",
  aboutSupplyCapabilities: "공급 역량",
  aboutMission: "우리의 미션",
  aboutMissionDesc: "신뢰할 수 있는 소싱, 엄격한 품질 관리, 종합적인 사후 지원을 통해 피트니스 브랜드와 리테일 바이어의 성장을 지원합니다.",

  navHome: "홈",
  navProducts: "제품",
  navCustomization: "맞춤 서비스",
  navSolutions: "솔루션",
  navAbout: "회사 소개",
  navContact: "문의하기",

  btnContactUs: "문의하기",
  btnLogin: "로그인",
  btnAccount: "계정",
  btnQuote: "견적 요청",
  btnCurrency: "통화",
  btnLanguage: "언어",

  requestQuote: "견적 요청",
  trustTitle: "글로벌 파트너 및 신뢰",
  factoryStatsSize: "30,000㎡ 공장 규모",
  factoryStatsQC: "생산 중 및 생산 후 100% 전수 품질 검사",
  homeAriaTrust: "신뢰 및 파트너 섹션",
  homeAriaStats: "공장 통계 및 수치",

  authLogin: {
    welcomeBack: "다시 오신 것을 환영합니다",
    brandIntro: "요가 및 피트니스 제품 소싱을 계속하려면 로그인하세요.",
    brandBullet1: "빠른 RFQ 워크플로우",
    brandBullet2: "제품/주문 추적",
    brandBullet3: "B2B 계정 지원",
    accountLogin: "계정 로그인",
    createAccount: "계정 만들기",
    recoverPassword: "비밀번호 재설정",
    registrationComplete: "가입 완료",
    passwordUpdated: "비밀번호 변경 완료",
    loginDesc: "사용자명 또는 이메일과 비밀번호로 로그인하세요.",
    registerDesc: "사용자명, 이메일 인증, 캡차로 계정을 생성하세요.",
    forgotDesc: "계정 이메일을 입력하여 재설정 코드를 받으세요.",
    registerSuccessDesc: "계정이 성공적으로 생성되었습니다. 자동으로 로그인 화면으로 돌아갑니다.",
    resetSuccessDesc: "비밀번호가 성공적으로 업데이트되었습니다. 자동으로 로그인 화면으로 돌아갑니다.",
    redirectHintPrefix: "페이지가",
    redirectHintSuffix: "후 로그인 화면으로 전환됩니다.",
    seconds: "초",
    loginNow: "지금 로그인",
    username: "사용자명",
    usernamePlaceholder: "최소 3자, 예: loya_buyer",
    usernameHelp: "사용자명은 최소 3자 이상이어야 하며, 예약어를 사용할 수 없고 영문/숫자/밑줄/하이픈만 사용할 수 있습니다.",
    usernameExistsHint: "이미 등록된 사용자명입니다. 바로 로그인하거나 다른 사용자명을 선택하세요.",
    usernameExists: "이미 존재하는 사용자명입니다. 다른 사용자명을 선택하거나 바로 로그인하세요.",
    usernameExistsAction: "사용자명 존재, 로그인으로 이동",
    usernameAlreadyRegistered: "이미 등록된 사용자명입니다.",
    usernameAvailable: "사용 가능한 사용자명입니다.",
    usernameVerifyFailed: "지금은 사용자명을 확인할 수 없습니다. 다시 시도해 주세요.",
    checkingUsername: "사용자명 사용 가능 여부 확인 중...",
    email: "이메일",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "인증 코드를 받을 이메일 주소를 입력하세요.",
    emailExistsHint: "이미 등록된 이메일입니다. 바로 로그인하거나 다른 이메일을 사용하세요.",
    emailExists: "이미 존재하는 이메일입니다. 다른 이메일을 사용하거나 로그인으로 이동하세요.",
    emailExistsAction: "이메일 존재, 로그인으로 이동",
    emailAlreadyRegistered: "이미 등록된 이메일입니다.",
    emailAvailable: "사용 가능한 이메일입니다.",
    emailVerifyFailed: "지금은 이메일을 확인할 수 없습니다. 다시 시도해 주세요.",
    checkingEmail: "이메일 사용 가능 여부 확인 중...",
    usernameOrEmail: "사용자명 또는 이메일",
    usernameOrEmailPlaceholder: "사용자명 또는 your@email.com",
    forgotEmailHint: "계정에 연결된 이메일 주소를 입력하면 재설정 코드를 보내드립니다.",
    password: "비밀번호",
    passwordPlaceholder: "비밀번호 입력",
    confirmPassword: "비밀번호 확인",
    confirmPasswordPlaceholder: "비밀번호 다시 입력",
    confirmNewPassword: "새 비밀번호 확인",
    confirmNewPasswordPlaceholder: "새 비밀번호 다시 입력",
    nickname: "닉네임",
    nicknamePlaceholder: "선택 사항(표시용)",
    captcha: "캡차",
    registerCaptcha: "회원가입 캡차",
    resetCaptcha: "재설정 캡차",
    refreshCaptcha: "캡차 새로고침",
    load: "불러오기",
    forgotCaptchaHint: "먼저 캡차를 완료한 뒤 비밀번호 재설정 코드를 요청하세요. 코드 전송 후 최종 단계용 새 캡차가 자동으로 로드됩니다.",
    registerCaptchaHint: "먼저 캡차를 완료한 뒤 이메일 인증 코드를 요청하세요.",
    registerStepHint: "먼저 사용자명, 비밀번호, 비밀번호 확인, 유효한 이메일을 입력하세요. 이후 캡차와 이메일 코드 영역이 표시됩니다.",
    emailCode: "이메일 코드",
    emailCodePlaceholder: "6자리 코드",
    resetCode: "재설정 코드",
    resetCodePlaceholder: "6자리 재설정 코드",
    sending: "전송 중...",
    resendIn: "재전송까지",
    sendEmailCode: "이메일 코드 전송",
    sendResetCode: "재설정 코드 전송",
    signingIn: "로그인 중...",
    login: "로그인",
    updating: "업데이트 중...",
    creating: "생성 중...",
    resetPassword: "비밀번호 재설정",
    forgotRequirementHint: "비밀번호 복구에는 캡차 인증과 이메일로 전송된 재설정 코드가 필요합니다.",
    registerRequirementHint: "회원가입에는 받은편지함으로 전송된 이메일 인증 코드가 필요합니다.",
    captchaRefreshHint: "캡차가 잘 보이지 않으면 오른쪽 이미지를 클릭해 새로고침하세요.",
    switchToLogin: "이미 계정이 있으신가요? 지금 로그인",
    switchToRegister: "아직 계정이 없으신가요? 지금 가입",
    backToLogin: "로그인으로 돌아가기",
    forgotPassword: "비밀번호를 잊으셨나요?",
    usernameRequired: "최소 3자의 사용자명을 입력하세요.",
    usernameMin: "사용자명은 최소 3자 이상이어야 합니다.",
    usernameMax: "사용자명은 24자를 초과할 수 없습니다.",
    usernamePattern: "사용자명에는 영문, 숫자, 밑줄, 하이픈만 사용할 수 있습니다.",
    usernameReserved: "예약된 사용자명입니다. 다른 이름을 선택해 주세요.",
    usernameFormatOk: "사용자명 형식이 올바릅니다.",
    emailRequired: "이메일 주소를 입력해 주세요.",
    emailInvalid: "유효한 이메일 주소를 입력해 주세요.",
    emailFormatOk: "이메일 형식이 올바릅니다.",
    emailProviderHint: "가능하면 Gmail, Outlook, QQ Mail, 163, 126, Foxmail 같은 일반적인 이메일 서비스를 사용해 주세요.",
    passwordRequired: "비밀번호를 입력해 주세요.",
    didYouMean: "혹시 이 뜻인가요",
    passwordMin: "비밀번호는 최소 6자 이상이어야 합니다.",
    newPasswordMin: "새 비밀번호는 최소 6자 이상이어야 합니다.",
    confirmPasswordRequired: "비밀번호 확인을 입력해 주세요.",
    passwordMatch: "비밀번호가 일치합니다.",
    passwordMismatch: "비밀번호가 일치하지 않습니다.",
    emailCodeRequired: "이메일 인증 코드를 입력해 주세요.",
    resetCodeRequired: "이메일로 받은 재설정 코드를 입력해 주세요.",
    captchaRequired: "캡차 코드를 입력해 주세요.",
    captchaExpired: "캡차가 만료되었습니다. 새로고침 후 다시 시도해 주세요.",
    captchaIncorrect: "캡차 코드가 올바르지 않습니다. 다시 시도해 주세요.",
    registerPrerequisitesError: "이메일 인증 코드를 요청하기 전에 사용자명, 비밀번호, 비밀번호 확인, 유효한 이메일을 먼저 입력해 주세요.",
    enterCaptchaBeforeEmailCode: "이메일 인증 코드를 요청하기 전에 캡차를 먼저 입력해 주세요.",
    enterCaptchaBeforeResetCode: "비밀번호 재설정 코드를 요청하기 전에 캡차를 먼저 입력해 주세요.",
    sendEmailCodeFailed: "이메일 인증 코드 전송에 실패했습니다.",
    emailCodeSent: "이메일 인증 코드가 전송되었습니다.",
    emailCodeSentInbox: "이메일 인증 코드가 전송되었습니다. 받은 편지함을 확인해 주세요.",
    previewCodeCurrentEnv: "현재 환경의 미리보기 코드",
    previewCodeDevelopment: "개발 환경의 미리보기 코드",
    previewCodeGenerated: "이메일 인증 코드가 생성되었습니다. 이 환경에서는 미리보기 코드를 사용합니다.",
    previewCodeContinueRegistration: "이 6자리 코드를 입력하여 회원가입을 계속하세요.",
    tooManyRequests: "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
    smtpConfigRetry: "이메일 전송에 실패했습니다. SMTP 설정을 확인하고 다시 시도해 주세요.",
    emailServiceNotConfigured: "이메일 서비스가 설정되지 않았습니다. 관리자에게 문의해 주세요.",
    requestFailed: "요청에 실패했습니다. 다시 시도하거나 지원팀에 문의해 주세요.",
    registerFailed: "회원가입 실패",
    resetFailed: "비밀번호 재설정 실패",
    loginFailed: "로그인 실패",
    registerSuccessNotice: "회원가입이 완료되었습니다. 약 4초 후 로그인 화면으로 이동합니다.",
    resetSuccessNotice: "비밀번호가 성공적으로 재설정되었습니다. 약 1.5초 후 로그인 화면으로 이동합니다.",
    loginTokenMissing: "로그인 토큰이 없습니다",
    profileLoadFailed: "계정 프로필을 불러오지 못했습니다",
    loginSuccessAdmin: "로그인 성공. 이동 중...",
    loginSuccessStorefront: "로그인 성공. 스토어프론트로 이동 중...",
    loginServiceUnavailable: "로그인 서비스를 현재 사용할 수 없습니다. 잠시 후 다시 시도해 주세요.",
    accountNotFound: "계정이 없습니다. 사용자명 또는 이메일을 확인해 주세요.",
    passwordIncorrect: "비밀번호가 올바르지 않습니다. 다시 시도해 주세요.",
    registrationNotOpen: "현재 로그인과 회원가입이 무을되어 있습니다.",
    accountRestricted: "이 계정은 로그인이 제한되어 있습니다. 관리자에게 문의해 주세요.",
    orContinueWith: "또는 계속하기",
    googleAuthorizing: "Google 계정 인증 중...",
    googleFallbackAction: "Google로 계속하기",
    googleAuthFailed: "Google 인증에 실패했습니다",
    googleAuthOffline: "오프라인 상태에서는 Google 로그인을 일시적으로 사용할 수 없습니다. 인터넷에 연결하거나 아이디/비밀번호를 사용해 주세요.",
    googleAuthTimeout: "Google 인증 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요. 계속 실패하면 관리자에게 백엔드 외부 네트워크 접근 확인을 요청하세요.",
    googleAuthNetworkError: "백엔드 네트워크 오류로 Google 인증에 실패했습니다. 관리자에게 문의해 주세요.",
    googleRegisterSuccess: "Google 계정이 성공적으로 연결되었습니다. 스토어프론트로 이동 중...",
    googleCreateAccountTitle: "Google 가입 완료",
    googleCreateAccountDesc: "Google이 이메일을 인증했습니다. 비밀번호를 설정하여 고객 계정을 만들고 로그인을 완료하세요.",
    googleCreateAccountHint: "이 Google 이메일에 대한 계정이 아직 없습니다. 비밀번호를 설정하여 고객 계정을 만드세요.",
    googleLinkedEmailHint: "이 확인된 Google 이메일로 고객 계정이 생성됩니다.",
    googleCreatePasswordHint: "비밀번호를 설정하고 확인해 주세요. 새 고객 계정은 Google에서 확인된 이메일을 사용합니다.",
    submitLogin: "로그인",
    submitRegister: "회원가입",
    submitReset: "비밀번호 재설정"
  },

  admin: {
    productCategoryYogaMats: "요가 매트",
    productCategoryYogaBlocks: "요가 블록",
    productCategoryYogaStraps: "요가 스트랩",
    productCategoryResistanceBands: "저항 밴드",
    productCategoryPilatesRings: "필라테스 링",
    productCategoryFoamRollers: "폼 롤러",
    productCategoryOthers: "기타",

    faqSampleOrderQ: "샘플 주문이 가능한가요?",
    faqSampleOrderA: "네, 샘플 주문을 지원합니다. 언제든지 문의해 주세요.",
    faqCustomPackagingQ: "맞춤 포장과 로고 서비스를 제공하나요?",
    faqCustomPackagingA: "네, 맞춤형 OEM/ODM 서비스를 제공합니다.",
    faqLeadTimeQ: "리드타임은 얼마나 되나요?",
    faqLeadTimeA: "일반적으로 주문 수량에 따라 1~3일 정도 소요되며, 최종 리드타임은 주문 후 확인됩니다.",
    faqDefectiveItemQ: "불량품은 어떻게 처리되나요?",
    faqDefectiveItemA: "출하일 기준 1년 보증을 제공합니다. 보증 기간 내 당사 자재 또는 제조상의 문제로 불량이 발생한 경우 설명, 사진 또는 영상, 필요 시 불량 샘플까지 제공해 주세요. 엔지니어가 분석 후 해결책을 제시합니다. 반품을 원하실 경우 원래 포장 및 부속품과 함께 반송해 주시면, 반품 수령 후 환불하거나 무료 교체품을 발송해 드립니다.",
    faqWhyChooseUsQ: "왜 우리를 선택해야 하나요?",
    faqWhyChooseUsA: "당사 제품은 낮은 MOQ와 높은 품질을 갖추고 있으며 미국 또는 EU 기준을 충족합니다. 높은 수준의 서비스와 OEM, Trade Assurance를 지원하므로 안심하고 거래하실 수 있습니다.",

    companyImageSectionOverview: "회사 개요",
    companyImageSectionAdvantages: "경쟁 우위",
    companyImageSectionCustomization: "맞춤화 역량",
    companyImageSectionExtended: "확장 회사 프로필",
    companyImageSectionPackaging: "포장 및 배송 사양",
    companyImageSectionFactory: "공장 프로필",
    companyImageSectionWorkflow: "생산 워크플로",
    companyImageSectionTradeShow: "전시회 활동",

    orderStatusPaid: "결제 완료",
    orderStatusPacked: "포장 완료",
    orderStatusInTransit: "운송 중",
    orderStatusDelivered: "배송 완료",
    orderStatusCancelled: "취소됨",

    tabDescHome: "여기에서 워크스페이스 운영과 성과를 관리하세요.",
    tabDescStoreBase: "프론트엔드/관리자 주소와 SEO 메타데이터를 설정하세요.",
    tabDescTemplateStudio: "스토어프론트 레이아웃 모듈을 시각적으로 편집하고 맞춤 템플릿을 저장하세요.",
    tabDescArticleManagement: "창 기반 편집기로 블로그 기사를 관리하세요.",
    tabDescCompanyImages: "스토어 회사 프로필에 사용되는 회사 이미지 카테고리를 관리하세요.",
    tabDescDesignNav: "프론트엔드 내비게이션과 중첩 메뉴 구조를 설정하세요.",
    tabDescDesignCarousel: "프론트엔드 홈 캐러셀 배너를 관리하세요.",
    tabDescDesignBanner: "배너 메시지와 CTA 콘텐츠를 설정하세요.",
    tabDescFaqKnowledge: "운영 및 영업팀을 위한 FAQ 지식 베이스를 유지하세요.",
    tabDescProducts: "제품 카탈로그, 상세 정보 및 가격 정보를 관리하세요.",
    tabDescProductCreate: "새 제품을 만들고 모든 정보와 미디어를 입력하세요.",
    tabDescMerchandising: "후보 상품, 가격 구조, 출시 준비 상태를 평가하세요.",
    tabDescProcurement: "구매 계획, 공급업체 진행 상황 및 소싱 우선순위를 조율하세요.",
    tabDescQuality: "품질 검사 포인트와 출고 준비 상태를 추적하세요.",
    tabDescLogistics: "선적 상태, 포장 준비, 물류 조율을 추적하세요.",
    tabDescOrders: "전체 주문 생애주기, 이행 및 배송 업데이트를 추적하세요.",
    tabDescCustomers: "팀 구성원과 계정 권한을 관리하세요.",
    tabDescMarketing: "마케팅 캠페인 상태와 성장 성과를 확인하세요.",
    tabDescDiscounts: "가격 전략과 프로모션 규칙을 관리하세요.",
    tabDescFinance: "재무 기록과 매출 추이를 모니터링하세요.",
    tabDescFinanceIncome: "주문 수금, 인식 매출 및 수입 장부 기록을 검토하세요.",
    tabDescFinanceExpenses: "구매, 물류, 마케팅, 오피스 비용 청구서를 추적하세요.",
    tabDescFinanceReceivables: "미수금, 연령 분석 및 수금 우선순위를 추적하세요.",
    tabDescFinancePayables: "미지급금, 공급업체 지급 및 만기 압박을 관리하세요.",
    tabDescFinanceInvoices: "청구서, 영수증 및 결제 상태를 관리하세요.",
    tabDescFinanceTax: "출력세, 입력세 및 세금 예상액을 검토하세요.",
    tabDescFinanceBudget: "예산, 비용 배분 및 초과 지출 알림을 추적하세요.",
    tabDescFinanceDaily: "일별 수입, 지출 및 순현금을 요약하세요.",
    tabDescFinanceMonthly: "월말 결산을 완료하고 수익 및 예산 편차를 검토하세요.",
    tabDescFinanceYearly: "연간 매출, 비용, 세금 및 순이익을 검토하세요.",
    tabDescFinanceReconciliation: "미수금, 수금, 미지급금, 청구서 및 세금 상태를 조정하세요.",
    tabDescFinanceApprovals: "환불, 지급 및 비용 승인 감사를 처리하세요.",
    tabDescFinanceReports: "재무 보고서, 운영 지표 및 내보내기 작업을 요약하세요.",
    tabDescAnalytics: "차트 인사이트와 운영 지표를 분석하세요.",
    tabDescSettings: "데이터베이스 연결 등 핵심 시스템 설정을 관리하세요.",
    tabDescWorkTargets: "일일 업무 목표를 추적하고 조율하세요.",
    tabDescWorkProcessing: "사용자 정의 워크플로와 실행 로그를 처리하세요.",
    tabDescHrEmployee: "직원 파일과 계정 정보를 조회 및 유지하세요.",
    tabDescHrRecruitment: "채용 관련 온보딩과 작업 대기열을 추적하세요.",
    tabDescHrAttendance: "직원 출석 및 계정 활동 상태를 모니터링하세요.",
    tabDescHrOffice: "직무 배치와 내부 행정 업무를 관리하세요.",
    tabDescSiteMaintenance: "프론트엔드 콘텐츠와 사이트 안정성을 유지하세요.",
    tabDescPermissionMaintenance: "역할 기반 권한과 접근 범위를 유지하세요.",
    tabDescPositionMaintenance: "직위 구조와 사용자 매핑을 유지하세요.",
    tabDescProfile: "계정 정보를 확인하세요.",
    tabDescPassword: "계정 비밀번호를 안전하게 변경하세요.",
    tabDescInquiry: "판매자와 소통하고 문의 대화를 추적하세요.",
    tabDescWishlist: "저장된 제품과 선호 선택을 관리하세요.",
    tabDescOrderProcessing: "주문 생애주기 전반의 주문 기록을 추적하고 처리하세요.",
    tabDescAfterSales: "애프터서비스 요청과 지원 티켓을 처리하세요.",

    roleDeveloper: "개발자",
    roleSuperAdmin: "최고 관리자",
    roleAdmin: "관리자",
    roleCustomer: "고객",
    roleGuest: "게스트",

    productCreateMenu: "제품 게시",
    productsMenu: "제품 목록",
    merchandisingOverview: "상품 운영 개요",
    merchandisingCollection: "선정 풀",
    internalOverview: "개요 및 설정",
    internalWorkspace: "제품 및 실행",
    internalBusiness: "영업 및 고객",
    internalOffice: "직무 업무",
    internalMaintenance: "유지보수 보드",
    storefrontContent: "스토어프론트 콘텐츠",
    guestService: "게스트 서비스",
    customerService: "고객 서비스",
    commonAccount: "내 계정",
    siteMaintenanceMenu: "직위 유지보수",
    positionMaintenanceMenu: "사용자 관리",

    title: "내 스토어",
    home: "운영 개요",
    storeDesign: "스토어 설정",
    companyProfile: "회사 프로필",
    storeBase: "스토어 기본 설정",
    templateStudio: "템플릿 스튜디오",
    articleManagement: "기사 관리",
    companyProfileMenu: "회사 프로필",
    companyImages: "회사 이미지",
    designNav: "내비게이션 메뉴",
    designCarousel: "홈 캐러셀",
    designBanner: "배너 설정",
    faqKnowledge: "FAQ 지식 베이스",
    products: "제품 관리",
    productCreate: "제품 상세 추가",
    merchandising: "상품 운영 센터",
    procurement: "구매 센터",
    quality: "품질 센터",
    logistics: "물류 동기화",
    orders: "문의 및 주문",
    customers: "고객 관리",
    marketing: "마케팅 캠페인",
    discounts: "가격 전략",
    finance: "재무 개요",
    financeIncome: "수입 장부",
    financeExpenses: "비용 청구서",
    financeReceivables: "미수금",
    financePayables: "미지급금",
    financeInvoices: "청구서 관리",
    financeTax: "세금 관리",
    financeBudget: "예산 및 비용",
    financeDaily: "일일 청구",
    financeMonthly: "월말 결산",
    financeYearly: "연간 재무제표",
    financeReconciliation: "조정",
    financeApprovals: "승인 및 감사",
    financeReports: "보고서 및 내보내기",
    analytics: "데이터 분석",
    settings: "시스템 설정",
    menuCommon: "공통",
    menuInternal: "내부",
    menuWorkContent: "업무 내용",
    menuMaintenance: "유지보수 보드",
    userManagementGroup: "유지보수 보드",
    menuGuest: "게스트",
    menuCustomer: "고객",
    workTargets: "업무 목표",
    workProcessing: "업무 처리",
    hrEmployee: "직원 기록",
    hrRecruitment: "채용 관리",
    hrAttendance: "출석 관리",
    hrOffice: "행정 업무",
    siteMaintenance: "직위 유지보수",
    permissionMaintenance: "권한 유지보수",
    positionMaintenance: "사용자 관리",
    profile: "개인 정보",
    password: "비밀번호 변경",
    inquiry: "문의 채팅",
    wishlist: "위시리스트",
    orderProcessing: "주문 처리",
    afterSales: "애프터서비스",

    profileCardTitle: "계정 프로필",
    accountId: "계정 ID",
    profileName: "이름",
    profileEmail: "이메일",
    profileRole: "역할",
    passwordCardTitle: "계정 비밀번호 변경",
    currentPassword: "현재 비밀번호",
    adminResetPasswordHint: "이 기능은 관리자가 특정 사용자의 비밀번호를 재설정할 때 사용합니다. 사용자의 현재 비밀번호는 필요하지 않습니다.",
    newPassword: "새 비밀번호",
    confirmPassword: "새 비밀번호 확인",
    savePassword: "비밀번호 업데이트",
    passwordUpdated: "비밀번호가 성공적으로 업데이트되었습니다.",

    inquiryCardTitle: "문의 센터",
    inquiryCardBody: "제품 요구사항, 가격 및 납기 일정에 대해 판매팀과 소통하세요.",
    openInquiryCenter: "문의 페이지 열기",
    openWhatsappChat: "WhatsApp 채팅",

    permissionSectionTitle: "현재 권한",
    permissionSectionBody: "권한은 로그인 응답과 직위 구조를 기반으로 파생됩니다.",
    placeholderTodo: "이 모듈은 현재 직위에 대해 열려 있습니다. 여기에서 구체적인 비즈니스 작업을 확장할 수 있습니다.",

    systemConfigTitle: "시스템 설정 센터",
    settingsTabDatabase: "데이터베이스",
    settingsTabDatabaseHint: "연결 및 풀 설정",
    settingsTabEmail: "이메일",
    settingsTabEmailHint: "브랜딩 및 트랜잭션 템플릿",
    mysqlHost: "MySQL 호스트",
    mysqlPort: "MySQL 포트",
    mysqlDatabase: "MySQL 데이터베이스명",
    mysqlUser: "MySQL 사용자명",
    mysqlPassword: "MySQL 비밀번호",
    mysqlPoolSize: "MySQL 풀 크기",
    mysqlConnectTimeoutMs: "MySQL 타임아웃(ms)",
    saveSystemConfig: "시스템 설정 저장",
    systemConfigSavedToast: "시스템 설정이 저장되었습니다",
    systemConfigPathLabel: "설정 파일",
    restartRequiredHint: "새 데이터베이스 설정을 적용하려면 백엔드 서비스를 재시작해야 합니다.",

    storefrontTitle: "스토어프론트 제목",
    adminTitle: "관리자 패널 제목",
    seoMetaTitle: "SEO 제목",
    seoDescription: "SEO 설명",
    seoKeywords: "SEO 키워드",
    seoCanonicalUrl: "정규 URL",
    seoRobots: "SEO Robots",
    seoOgTitle: "Open Graph 제목",
    seoOgDescription: "Open Graph 설명",
    seoOgImage: "Open Graph 이미지 URL",
    seoTwitterCard: "Twitter 카드 유형",
    seoTwitterSite: "Twitter 사이트 핸들",
    saveBaseSettings: "기본 설정 저장",
    baseSavedToast: "기본 설정이 저장되었습니다",

    hello: "안녕하세요, 시작해 봅시다.",
    askAnything: "무엇이든 물어보세요...",
    supportLine: "질문이 있으신가요? 지원팀에 문의하세요",
    addStoreName: "스토어 이름 추가",
    firstProduct: "첫 번째 제품 추가",
    firstProductDesc: "제품을 추가하고 핵심 정보를 입력하는 것부터 시작하세요.",
    addProduct: "제품 추가",
    importData: "가져오기",
    customizeStore: "스토어 맞춤 설정",
    customizeStoreDesc: "템플릿을 선택하고 로고, 색상, 이미지를 추가하세요.",
    customTemplate: "맞춤 템플릿",
    payments: "커머스 결제 설정",
    shipping: "배송 요금 확인",
    domain: "맞춤 도메인",
    quickSales: "마켓 판매 간소화",
    quickSalesDesc: "여러 플랫폼에서 영업과 관리를 동기화하세요.",
    storeSettings: "스토어 설정",
    general: "일반",
    billing: "청구",
    usersPermissions: "사용자",

    paginationPrevious: "이전",
    paginationNext: "다음",
    paginationPage: "페이지",
    paginationTotal: "/",

    policies: "정책",
    businessInfo: "비즈니스 정보",
    contactInfo: "스토어 연락처",
    defaults: "스토어 기본값",
    businessMode: "비즈니스 모드",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "스토어 모드가 업데이트되었습니다",
    modeSavedToast: "비즈니스 모드가 성공적으로 전환되었습니다",

    navSettings: "내비게이션 메뉴",
    navLabel: "하위 메뉴 라벨",
    navPath: "하위 메뉴 링크",
    addSubmenu: "하위 메뉴 추가",
    saveNavigation: "하위 메뉴 저장",
    navSavedToast: "내비게이션 메뉴가 저장되었습니다",

    bannerSettings: "배너 목록",
    bannerTitle: "배너 제목",
    bannerAnnotation: "이미지 설명",
    bannerButtonText: "버튼 텍스트",
    bannerButtonLink: "버튼 링크",
    bannerImageUrl: "배너 이미지 URL",
    addBanner: "배너 추가",
    removeBanner: "제거",
    saveBanners: "배너 저장",
    bannersSavedToast: "배너 목록이 저장되었습니다",

    saveFaqKnowledge: "FAQ 저장",
    faqKnowledgeSavedToast: "FAQ 지식 베이스가 저장되었습니다",
    saveCompanyImages: "회사 이미지 저장",
    companyImagesSavedToast: "회사 이미지 설정이 저장되었습니다",
    companyIntroductionTitle: "회사 소개",
    companyIntroductionHint: "회사 프로필, 강점 및 서비스 역량을 표시하는 데 사용됩니다.",
    companyIntroductionPlaceholder: "회사 소개 내용을 입력하세요...",
    addImageUrl: "이미지 URL 추가",
    uploadLocalImages: "로컬 이미지 업로드",
    addFaq: "FAQ 추가",
    saveCarouselImages: "캐러셀 이미지 저장",
    carouselImagesSavedToast: "캐러셀 이미지가 저장되었습니다",

    close: "닫기",
    save: "저장",
    create: "생성",
    search: "현재 보기 검색",
    refresh: "새로고침",
    createProduct: "제품 추가",
    cancel: "취소",
    edit: "수정",
    remove: "삭제",

    systemSnapshot: "시스템 스냅샷",
    activeSearch: "활성 검색",
    none: "(없음)",
    orderRecords: "주문 기록",
    userRecords: "사용자 기록",
    lastRefresh: "마지막 새로고침",
    productsCount: "제품",
    customersCount: "고객",
    ordersCount: "주문",
    revenue: "매출 USD",

    localeLabel: "로케일",
    sku: "SKU",
    name: "이름",
    description: "설명",
    price: "가격 USD",
    imageUrl: "이미지 URL",
    category: "카테고리",
    model: "모델",
    titleField: "제품 제목",
    detailVideo: "상세 동영상 URL",
    mainImages: "대표 이미지 (6개 링크, 줄바꿈으로 구분)",
    detailImages: "상세 이미지 (한 줄에 한 링크)",
    parameters: "파라미터 (한 줄에 key:value)",
    openCreateProduct: "제품 폼 열기",

    id: "ID",
    serialNumber: "#",
    userId: "사용자",
    actions: "작업",
    email: "이메일",
    role: "역할",
    username: "사용자명",
    nickname: "닉네임",
    userRole: "사용자 역할",
    phone: "전화",
    accountStatus: "계정 상태",
    jobTitle: "직책",
    registeredAt: "가입일",
    lastActiveAt: "마지막 활동",
    statusActive: "활성",
    statusDisactive: "비활성",
    permissions: "권한",
    position: "직위",
    accessSummary: "접근",
    positionName: "직위명",
    positionKey: "직위 키",
    department: "부서",
    addPosition: "직위 추가",
    permissionName: "권한 이름",
    permissionKey: "권한 키",
    addPermission: "권한 추가",
    editPermissions: "권한 수정",
    permissionSelectTitle: "권한 선택",
    permissionSelectedSummary: "선택됨",
    permissionQuickSearchPlaceholder: "키 또는 주석으로 빠르게 검색",
    defaultAdminPosition: "운영 관리자",

    orderId: "주문 ID",
    total: "합계",
    status: "상태",
    cartItems: "장바구니 항목",
    logout: "로그아웃",
    changePasswordAction: "비밀번호 변경",
    userPasswordModalTitle: "사용자 비밀번호 수정",
    userPasswordUpdated: "사용자 비밀번호가 성공적으로 업데이트되었습니다.",
    targetUser: "대상 사용자",
    userDataResyncedHint: "저장 후 서버 측 필드 덮어쓰기가 감지되어 최신 데이터로 다시 동기화되었습니다.",
    userManagementRestrictedHint: "이 작업에는 더 높은 권한이 필요합니다.",

    capability: {
      "admin:overview:read": "관리자 개요 읽기",
      "admin:products:read": "관리자 제품 읽기",
      "admin:products:write": "관리자 제품 쓰기",
      "admin:orders:read": "관리자 주문 읽기",
      "admin:orders:write": "관리자 주문 쓰기",
      "admin:users:read": "관리자 사용자 읽기",
      "admin:users:role:write": "사용자 역할 쓰기",
      "admin:users:position:assign": "사용자 직위 할당",
      "admin:storefront:read": "스토어프론트 설정 읽기",
      "admin:storefront:write": "스토어프론트 설정 쓰기",
      "admin:system-config:read": "시스템 설정 읽기",
      "admin:system-config:write": "시스템 설정 쓰기",
      "shop:profile:read": "스토어 프로필 읽기",
      "shop:password:write": "스토어 비밀번호 쓰기",
      "shop:orders:read": "스토어 주문 읽기",
      "shop:inquiry:write": "스토어 문의 처리",
      "shop:wishlist:read": "위시리스트 읽기",
      "shop:orders:processing:read": "주문 처리 읽기",
      "shop:after-sales:read": "애프터서비스 읽기",
      "internal:work:targets:read": "업무 목표 읽기",
      "internal:work:processing:read": "업무 처리 읽기",
      "internal:maintenance:site:write": "사이트 유지보수 쓰기",
      "internal:maintenance:permission:write": "권한 유지보수 쓰기",
      "internal:maintenance:position:write": "직위 유지보수 쓰기",
      "shop:products:read": "스토어 제품 읽기",
      "shop:storefront:read": "스토어프론트 읽기",
      "internal:system:config:read": "내부 시스템 설정 읽기",
      "internal:system:config:write": "내부 시스템 설정 쓰기",
      "internal:security:audit:read": "보안 감사 읽기",
      "internal:security:session:revoke": "세션 철회",
      "internal:integration:manage": "연동 관리",
      "admin:users:write": "관리자 사용자 쓰기",
      "admin:users:password:reset": "사용자 비밀번호 재설정",
      "admin:users:delete": "관리자 사용자 삭제",
      "crm:customer:read": "고객 프로필 읽기",
      "crm:customer:write": "고객 프로필 쓰기",
      "crm:customer:assign": "고객 소유권 할당",
      "website:content:read": "웹사이트 콘텐츠 읽기",
      "website:content:write": "웹사이트 콘텐츠 쓰기",
      "website:navigation:write": "웹사이트 내비게이션 쓰기",
      "website:banner:write": "웹사이트 배너 쓰기",
      "website:seo:write": "웹사이트 SEO 쓰기",
      "website:theme:write": "웹사이트 테마 쓰기",
      "website:publish": "웹사이트 콘텐츠 게시",
      "admin:products:create": "관리자 제품 생성",
      "admin:products:delete": "관리자 제품 삭제",
      "merchandising:selection:read": "선정 풀 읽기",
      "merchandising:selection:write": "선정 풀 쓰기",
      "catalog:pricing:write": "카탈로그 가격 쓰기",
      "catalog:inventory:write": "카탈로그 재고 쓰기",
      "catalog:translation:write": "카탈로그 번역 쓰기",
      "sales:inquiry:read": "영업 문의 읽기",
      "sales:inquiry:reply": "영업 문의 답변",
      "sales:quotation:create": "영업 견적 생성",
      "sales:quotation:approve": "영업 견적 승인",
      "sales:contract:write": "영업 계약 쓰기",
      "sales:sample:manage": "샘플 워크플로 관리",
      "order:status:update": "주문 상태 업데이트",
      "order:split:merge": "주문 분할/병합",
      "procurement:purchase:write": "구매 주문 쓰기",
      "production:plan:write": "생산 계획 쓰기",
      "qa:inspection:write": "품질 검사 쓰기",
      "logistics:shipment:write": "선적 정보 쓰기",
      "logistics:tracking:read": "물류 추적 읽기",
      "trade:customs:doc:write": "통관 문서 쓰기",
      "finance:invoice:read": "송장 읽기",
      "finance:invoice:write": "송장 쓰기",
      "finance:payment:read": "결제 읽기",
      "finance:payment:write": "결제 쓰기",
      "finance:refund:approve": "환불 승인",
      "finance:reconciliation:write": "재무 정산 쓰기",
      "finance:tax:write": "세금 정보 쓰기",
      "marketing:campaign:read": "마케팅 캠페인 읽기",
      "marketing:campaign:write": "마케팅 캠페인 쓰기",
      "marketing:coupon:write": "쿠폰 쓰기",
      "marketing:lead:export": "리드 내보내기",
      "analytics:dashboard:read": "분석 대시보드 읽기",
      "analytics:report:export": "분석 리포트 내보내기",
      "support:ticket:read": "지원 티켓 읽기",
      "support:ticket:write": "지원 티켓 쓰기",
      "support:return:approve": "반품 요청 승인",
      "support:complaint:handle": "고객 불만 처리",
      "office:announcement:write": "사내 공지 쓰기",
      "office:document:read": "사내 문서 읽기",
      "office:document:write": "사내 문서 쓰기",
      "office:workflow:approve": "사내 워크플로 승인",
      "office:meeting:manage": "회의 일정 관리",
      "hr:employee:read": "직원 기록 읽기",
      "hr:employee:write": "직원 기록 쓰기"
    }
  }
};